import React, { memo } from 'react';
import { useTranslation } from '@dm/i18n';
import { theme } from '../../..';
import { IconProps, DEFAULT_IMAGE_SIZE } from '../icon';
import IconSvg from '../IconSvg';

const HeartStroke = (props: IconProps) => {
  const [t] = useTranslation();
  const {
    id,
    color = theme.palette.color2.hex,
    description,
    dmId = 'dm-heart-stroke',
    pointerEvents = 'none',
    secondColor = theme.palette.color5.hex,
    size = DEFAULT_IMAGE_SIZE,
    title = t('ds.icon.heartStroke.title'),
    ...otherProps
  } = props; // we also need to define unused props because of otherProps

  return (
    <IconSvg
      id={id}
      description={description}
      dmId={dmId}
      pointerEvents={pointerEvents}
      size={size}
      title={title}
      {...otherProps}>
      <path
        fill={secondColor}
        d="M16.22,3.91c-1.89,0.04-3.56,1.25-4.24,3.05C11.29,5.15,9.6,3.94,7.69,3.91c-2.93,0-4.78,2.34-4.78,5.59
		c0,6.84,8.17,10.59,9.07,10.59c0.9,0,9.11-3.73,9.11-10.59C21.09,6.25,19.18,3.91,16.22,3.91z"
      />
      <path
        fill={color}
        d="M11.98,21C10.47,21,2,16.71,2,9.5C2,5.67,4.34,3,7.69,3c1.71,0.03,3.26,0.82,4.29,2.12
		C12.99,3.83,14.52,3.04,16.2,3l0.02,0C19.62,3,22,5.67,22,9.5C22,17.16,13.1,21,11.98,21z M7.68,4.82c-2.34,0-3.86,1.84-3.86,4.68
		c0,5.82,6.89,9.41,8.16,9.67c1.28-0.26,8.2-3.85,8.2-9.67c0-2.8-1.59-4.68-3.95-4.68c-1.52,0.04-2.85,1-3.4,2.46l-0.85,2.26
		l-0.85-2.26C10.57,5.81,9.22,4.84,7.68,4.82z"
      />
    </IconSvg>
  );
};

export default memo(HeartStroke);
